import * as actions from './actions';
import * as actionTypes from './actionTypes';
import reducer, { initialState } from './reducer';

export default {
  actions,
  actionTypes,
  initialState,
  reducer,
};
